import "./index.css"

import { App } from "./App.tsx"
import { AppGlobalDataProvider } from "@/contexts/app-global-data-context"
import { AuthProvider } from "@/contexts/auth-context.tsx"
import { CookiesProvider } from "react-cookie"
import { I18nProvider } from "@/components/I18nProvider.tsx"
import { NotificationProvider } from "@/contexts/notification-context"
import React from "react"
import ReactDOM from "react-dom/client"
import { ThemeProvider } from "@/components/ThemeProvider.tsx"
import Web3WalletProvider from "@/contexts/web3-wallet-context.tsx"

function initSentryWhenIdle() {
  if (!import.meta.env.PROD || !import.meta.env.VITE_SENTRY_DSN) return

  const initSentry = async () => {
    const Sentry = await import("@sentry/react")

    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
      // Setting this option to true will send default PII data to Sentry.
      // For example, automatic IP address collection on events
      sendDefaultPii: true,
    })
  }

  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(() => void initSentry(), { timeout: 10000 })
    return
  }

  globalThis.setTimeout(() => void initSentry(), 10000)
}

initSentryWhenIdle()

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <CookiesProvider defaultSetOptions={{ path: "/" }}>
      <I18nProvider>
        <Web3WalletProvider>
          <AuthProvider>
            <NotificationProvider>
              <AppGlobalDataProvider>
                <ThemeProvider>
                  <App />
                </ThemeProvider>
              </AppGlobalDataProvider>
            </NotificationProvider>
          </AuthProvider>
        </Web3WalletProvider>
      </I18nProvider>
    </CookiesProvider>
  </React.StrictMode>
)
